export default {
  filterSettings(
    activeFilters,
    allFiltersByType,
    { includeId = true, includeUuid = true } = {}
  ) {
    return activeFilters.map((filter) => {
      const { type, settings, columnName } = filter
      const filterType = allFiltersByType[type]

      const serializedFilter = {
        type: type,
        params: filterType.serializeSettings(settings),
        column_name: columnName,
      }

      if (includeUuid) {
        serializedFilter.uuid = filter.uuid
      }

      // TODO mixing uuid/id until it's clear if we could rely purely on uuid and use it as a PK
      if (includeId && filter.id) {
        serializedFilter.id = filter.id
      }

      return serializedFilter
    })
  },

  ledgerSelectSettings({ periodSelection, ledgerSelectDate }) {
    let params = {}
    if (periodSelection === 'financial_year') {
      params = { financial_year: true, date: ledgerSelectDate }
    } else if (periodSelection === 'accounting_period') {
      params = { accounting_period: true, date: ledgerSelectDate }
    }
    return params
  },
}
